import type { PublicSlotKey } from '#packages/apilib';
import type { QuickEditApi } from './quickEditApi';

export const QuickEditApiKey: PublicSlotKey<QuickEditApi> = {
  name: 'QuickEditApi',
  public: true,
};
